import Link from 'next/link'
import { format } from 'date-fns'
import ContentContainer from './ContentContainer'

interface PodcastsPagesListProps {
	heading?: string
	addArchiveLink?: any
	podcastsPages: Array<any>
}

const PodcastsPagesList = (props: PodcastsPagesListProps) => {

	const { heading, addArchiveLink, podcastsPages } = props

	if ( !podcastsPages || podcastsPages.length === 0 ) {
		return null
	}

	return (
		<ContentContainer
			heading={heading}
			modifierClass=""
			link={addArchiveLink ? <Link href="/podcasts" className='button button--inverted'>View all podcasts →</Link> : null}
		>
			<div className="flex-table">
				{podcastsPages.map((podcast: any, index: number) => {
					const podcastTitle = podcast.pageHeader?.[0]?.heading;
					const podcastText = podcast.pageHeader?.[0]?.text;
					return (
						<div key={index} className="flex-table__row flex-table__row--content flex-table__row--content__podcasts">
							<div className="flex-table__row-inner">
								<div className="flex-table__column flex-table__column__podcasts-title">{podcastTitle}</div>
								<div className="flex-table__column flex-table__column__podcasts-text" dangerouslySetInnerHTML={{ __html: podcastText }}/>
								<div className="flex-table__column flex-table__column__podcasts-link">
									<Link href={`/${podcast.uri}`} className='button button--standard'>Episodes</Link>
								</div>
							</div>
						</div>
					)
				})}
			</div>
		</ContentContainer>
	)

}
export default PodcastsPagesList
